<template>
    <div>
        <NuxtLayout>
            <NuxtPage />
        </NuxtLayout>

        <ClientOnly>
            <AuthModal
                v-if="isAuthModalOpen || hasOpenedAuthModal"
                v-model="isAuthModalOpen"
                :initial-tab="authModalInitialTab"
            />
        </ClientOnly>

        <!-- ModalsContainer is required for vue-final-modal v4 -->
        <ClientOnly>
            <ModalsContainer />
        </ClientOnly>
        <!-- Toast notifications -->
        <CToastContainer />

        <!-- Page-transition feedback. Client-only: there is no navigation to
             report during SSR, and rendering it on the server would only add
             markup that is immediately replaced. -->
        <ClientOnly>
            <GrowniPageLoader />
        </ClientOnly>
    </div>
</template>

<script setup lang="ts">
import { COLOR_MODE_BOOTSTRAP } from '@/utils/colorMode'
import { ModalsContainer } from 'vue-final-modal'
import CToastContainer from '@/components/ui/CToastContainer.vue'
import GrowniPageLoader from '@/components/common/GrowniPageLoader.vue'

// The auth forms are only downloaded when the modal is first opened, then stay mounted
// so closing it keeps its leave transition.
const AuthModal = defineAsyncComponent(() => import('@/components/auth/AuthModal.vue'))

const { isAuthModalOpen, authModalInitialTab } = useAuthModal()
const hasOpenedAuthModal = ref(false)
watch(isAuthModalOpen, (open) => {
    if (open) hasOpenedAuthModal.value = true
})


// Apply saved/system preference before the first paint, including static pages.
useHead({
    script: [{
        key: 'growni-color-mode',
        innerHTML: COLOR_MODE_BOOTSTRAP,
        tagPosition: 'head',
        tagPriority: 'critical',
        type: 'text/javascript'
    }]
})

// Site-wide canonical URL. Built from route.path so query strings never create
// duplicate URLs (e.g. /mentor/jan-novak?uid=... collapses to /mentor/jan-novak).
// Pages needing a different canonical override it with the same `key`.
const route = useRoute()
const canonicalUrl = computed(() => {
    const path = route.path.replace(/\/+$/, '')
    return `https://growni.sk${path || '/'}`
})

useHead({
    link: [{ rel: 'canonical', key: 'canonical', href: canonicalUrl }]
})
</script>
